import React from 'react';
import { Search, Wrench, TrendingUp } from 'lucide-react';
import { mockProcessSteps } from '../mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const iconMap = {
  Search: Search,
  Wrench: Wrench,
  TrendingUp: TrendingUp
};

export const ProcessSection = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [gridRef, gridVisible] = useScrollAnimation();
  
  return (
    <section className="process-section" id="process">
      <div className="section-container">
        <div 
          ref={headerRef} 
          className={`section-header ${headerVisible ? 'animate-fade-in-up' : ''}`}
        >
          <h2 className="section-title">Our Process</h2>
          <p className="section-subtitle">
            A streamlined approach to transforming your operations with AI automation
          </p>
        </div>
        
        <div ref={gridRef} className="process-grid">
          {mockProcessSteps.map((step, index) => {
            const Icon = iconMap[step.icon];
            const delay = index * 200;
            return (
              <div 
                key={step.step} 
                className={`process-card ${gridVisible ? 'animate-fade-in-up' : ''}`}
                style={{ animationDelay: gridVisible ? `${delay}ms` : '0ms', opacity: gridVisible ? 1 : 0 }}
              >
                <div className="process-step-number">{step.step}</div>
                
                <div className="process-icon-wrapper">
                  <Icon className="process-icon" size={32} />
                </div>
                
                <h3 className="process-title">{step.title}</h3>
                <p className="process-description">{step.description}</p>
                
                {index < mockProcessSteps.length - 1 && (
                  <div className="process-connector"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
